// Consentement cookies / mesure d'audience (stocke le choix en localStorage — non soumis a consentement)
const KEY = "asap_cookie_consent";

export function getConsent() {
  try {
    return localStorage.getItem(KEY); // "accepted" | "refused" | null
  } catch {
    return null;
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem(KEY, value);
  } catch {}
  window.dispatchEvent(new Event("consent-change"));
}

export const hasAnalyticsConsent = () => getConsent() === "accepted";

// Réouvre la bannière de consentement pour permettre de modifier son choix
export function openCookieSettings() {
  window.dispatchEvent(new Event("open-cookie-settings"));
}
